//src/routes.js
import Callback from "./components/callback";
import React from "react";
import Auth from "./lib/auth";
import Home from "./components/home";
import { NoAuthUploadWrapper } from "./components/noAuthUpload";
import { NoAuthFileShareWrapper } from "./components/noAuthFileShare";
import { UserManagementWrapper } from "./components/userManagement";
import { RptSubscriptionWrapper } from "./components/reportSubscriptions";
import Mdm from "./components/mdm";
import InsightsDiscovery from "./components/insightsDiscovery";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import loadable from "@loadable/component";
import socketIOClient from "socket.io-client";
import { isMsalMode } from "./lib/authMode";
import ReportingShell from "./components/reportingShell";

const AsyncReports = loadable(() => import("./components/reports/index"));
const AsyncPowerBI = loadable(() => import("./components/powerBI"));
const AsyncFiles = loadable(() => import("./components/files"));
const AsyncPbiMgmt = loadable(() => import("./components/pbiMgmt"));
const AsyncStaticContent = loadable(() => import("./components/staticContent"));

var socket;

const TabsRouter = ({ store }) => {
  const authRef = React.useRef(new Auth(store));
  const auth = authRef.current;

  React.useEffect(() => {
    // In msal mode the session cookie authenticates the socket handshake, so
    // the browser must send credentials with it.
    socket = socketIOClient(process.env.REACT_APP_BIGHORN_SERVER, { withCredentials: isMsalMode() });

    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  return (
    <BrowserRouter>
      <React.Fragment>
        <App auth={auth} />
        <div className="tabsRouter" style={{ height: "100%", minHeight: 0, display: "flex" }}>
          <Routes>
            <Route path="/" element={<Home auth={auth} />} />
            <Route path="/home" element={<Home auth={auth} />} />
            <Route path="/" element={<ReportingShell />}>
              <Route path="reports/*" element={<AsyncReports auth={auth} store={store} />} />
              <Route path="powerBI/*" element={<AsyncPowerBI auth={auth} store={store} />} />
              <Route path="files/*" element={<AsyncFiles auth={auth} store={store} />} />
              <Route path="powerBIMgmt/*" element={<AsyncPbiMgmt auth={auth} store={store} />} />
              <Route path="reportSubscriptions/*" element={<RptSubscriptionWrapper auth={auth} store={store} />} />
              <Route path="mdm/*" element={<Mdm auth={auth} store={store} />} />
              <Route path="userManagement/*" element={<UserManagementWrapper auth={auth} store={store} />} />
              <Route path="insightsDiscovery/*" element={<InsightsDiscovery auth={auth} store={store} />} />
            </Route>
            <Route path="/sc/*" element={<AsyncStaticContent auth={auth} store={store} />} />
            <Route path="/callback" element={<Callback auth={auth} />} />
            <Route path="/setClient" element={<Callback auth={auth} />} />
            <Route path="/fileUpload/*" element={<NoAuthUploadWrapper auth={auth} store={store} />} />
            <Route path="/uploadFile/*" element={<NoAuthUploadWrapper auth={auth} store={store} />} />
            <Route path="/tabsFileShare/*" element={<NoAuthFileShareWrapper auth={auth} store={store} />} />
            <Route
              path="/noPermissions"
              element={
                <div className="login-wrapper">
                  <div className="login-msg">
                    You do not have any permissions set for any applications. Contact your administrator.
                  </div>
                </div>
              }
            />
          </Routes>
        </div>
      </React.Fragment>
    </BrowserRouter>
  );
};

export { TabsRouter, socket };
